import { formatPhoneNumber } from '@/common/helpers/phoneFormatUtils'
import { type VoiceCustomer } from '@/common/types/cti'

export function buildCustomerCtiQueryParams(customer: VoiceCustomer | null | undefined): Record<string, string> {
  const query: Record<string, string> = { isCti: 'true' }
  const phone = formatPhoneNumber(customer?.customerNumber ?? null)
  if (phone) {
    query.phone = phone
  }
  if (customer?.externalReference) {
    query.ref = customer.externalReference
  }
  return query
}
